<div class="warning">
  <h3>{{ "tw_warning_heading" | translate }}</h3>
  <p>{{ "tw_warning_message" | translate: [walletName] }}</p>
  @if (showLink) {
    <a class="link" [href]="link" target="_blank"> {{ "details_tx_item" | translate }}</a>
  }
</div>
